import React from 'react'
import { connect } from 'react-redux'
import { Creatable } from 'react-select'
// import Select from 'react-select'
import styled from 'styled-components'

import Page, { Container } from '../elements/Page.js'
import { Input, Label } from '../elements/Form'
import { logIn } from '../model/actions'
import { RaisedButton } from 'material-ui'

const Select = styled(Creatable)`
  width: 250px;
`

class Login extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      fieldValue: null,
    }
  }
  updateValue = newValue => {
    this.setState({ fieldValue: newValue })
  }
  logIn = () => {
    this.props.logIn(this.state.fieldValue)
    this.props.history.push('/')
  }
  render() {
    const { userSuggestions } = this.props

    const options = (this.state.fieldValue
      ? userSuggestions.add(this.state.fieldValue)
      : userSuggestions
    )
      .map(s => ({ label: s, value: s }))
      .toArray()

    return (
      <Page title="Log in">
        <Container>
          <Input>
            <Label>Who are you?</Label>
            <Select
              value={this.state.fieldValue}
              onChange={this.updateValue}
              options={options}
              placeholder="Enter your full name"
              simpleValue
            />
          </Input>
          <RaisedButton label="Log In" onClick={this.logIn} />
        </Container>
      </Page>
    )
  }
}

const mapState = state => {
  return {
    userSuggestions: state.data.get('userSuggestions'),
  }
}

const eventMap = {
  logIn,
}

export default connect(mapState, eventMap)(Login)



// WEBPACK FOOTER //
// ./src/Login/index.js